import type { DayAvailability, RoomType, RoomTypeCreate, RoomTypeUpdate } from "@/types";
import { apiClient } from "./client";

export const roomTypeService = {
  list: async (propertyId: string): Promise<RoomType[]> => {
    const { data } = await apiClient.get<RoomType[]>("/admin/room-types", {
      params: { property_id: propertyId },
    });
    return data;
  },

  create: async (body: RoomTypeCreate): Promise<RoomType> => {
    const { data } = await apiClient.post<RoomType>("/admin/room-types", body);
    return data;
  },

  update: async (id: string, body: RoomTypeUpdate): Promise<RoomType> => {
    const { data } = await apiClient.patch<RoomType>(`/admin/room-types/${id}`, body);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/room-types/${id}`);
  },

  availability: async (
    id: string,
    check_in: string,
    check_out: string
  ): Promise<DayAvailability[]> => {
    const { data } = await apiClient.get<DayAvailability[]>(
      `/admin/room-types/${id}/availability`,
      { params: { check_in, check_out } }
    );
    return data;
  },
};
